"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const DomHelper_1 = require("src/ts/helpers/DomHelper");
const defaultEmptyOption = { value: 'NOT', text: '' };
class Select extends React.Component {
    constructor(props) {
        super(props);
        this.renderOptions = () => {
            return this.props.options.map((option) => {
                return React.createElement("option", { key: option.value, value: option.value },
                    " ",
                    option.text,
                    " ");
            }).concat(React.createElement("option", { key: 'NOT', value: 'NOT', disabled: true, style: { display: 'none' } }));
        };
        this._onChange = (event) => {
            const selectedCountry = event.target.value;
            const searchOption = this.props.options.filter((option) => option.value === event.target.value);
            this.setState({
                selected: searchOption.length ? searchOption[0] : defaultEmptyOption,
            }, () => this.props.onChange(selectedCountry));
        };
        this._onFocus = () => {
            if (this.state.focused) {
                return;
            }
            this.setState({
                focused: true,
            });
        };
        this._onBlur = () => {
            if (!this.state.focused) {
                return;
            }
            this.setState({
                focused: false,
            });
        };
        this._autoFocus = (el) => {
            if (this.props.autoFocus && el && !this._domReference) {
                this._domReference = el;
                window.setTimeout(() => DomHelper_1.DomHelper.setFocus(this._domReference), 200);
            }
        };
        this.state = {
            selected: props.value || defaultEmptyOption,
            focused: props.autoFocus || false,
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({
                selected: nextProps.value || this.state.selected,
            });
        }
    }
    render() {
        let wrapperAdditionalClass = '';
        if (this.props.options.length <= 1) {
            wrapperAdditionalClass += ' noOptions';
        }
        if (this.state.focused) {
            wrapperAdditionalClass += ' focused';
        }
        return (React.createElement("div", { className: `selectWrapper ${wrapperAdditionalClass}` },
            React.createElement("strong", { className: 'selectTitle', "aria-hidden": 'true', tabIndex: -1 },
                React.createElement("span", { className: 'selected' }, this.state.selected.text),
                this.props.options.length > 1 && React.createElement("span", { className: 'iconFontBold', "data-icon": '\uE41E' })),
            this.props.options.length > 1 && React.createElement("select", { className: 'select', tabIndex: 0, "aria-label": this.props.ariaLabel, onChange: this._onChange, value: this.state.selected.value, ref: this._autoFocus, onFocus: this._onFocus, onBlur: this._onBlur }, this.renderOptions())));
    }
}
exports.Select = Select;
